
<section>
  <div class="dashboard flex justify-center mt-48 md:pb-50">
    <section>
      <div class="flex flex-col items-center text-center">
        <h2 v-if="headingText" class="text-h1 mx-16">{{ headingText }}</h2>
        <p v-if="subheadingText" class="text-small mx-16 my-8 text-grey-text-subdued">{{ subheadingText }}</p>
      </div>
      <div class="my-24 flex justify-center">
        <ul class="inline-grid grid-cols-2 lg:flex lg:flex-wrap lg:justify-center care-type-card m-8">
          <CareTypeCard
            v-for="careType in careTypes"
            :key="careType.key"
            :careType="careType"
            :selected="selectedCareType === careType"
            @click="selectCareType"
          />
        </ul>
      </div>
    </section>
  </div>
</section>
